import Screenshot from './Screenshot';

export default Screenshot;
